import { axios } from 'shared';

export type SlackUserConnectUrlResponse = {
  connect_url: string;
};

export type SlackUserOAuthCallbackResponse = {
  success: boolean;
  error?: string;
};

export type SlackUserStatusResponse = {
  connected: boolean;
  has_slack_installation: boolean;
  slack_user_id?: string;
  slack_email_at_link?: string;
  linked_via?: string;
};

export type SlackUserDisconnectResponse = {
  success: boolean;
  error?: string;
};

export function getSlackUserConnectUrl() {
  return axios.get<SlackUserConnectUrlResponse>('/v1/slack/user/connect_url');
}

export function completeSlackUserOAuth(code: string, state: string) {
  return axios.post<SlackUserOAuthCallbackResponse>('/v1/slack/user/oauth/callback', { code, state });
}

export function disconnectSlackUser() {
  return axios.delete<SlackUserDisconnectResponse>('/v1/slack/user/disconnect');
}

export function getSlackUserStatus() {
  return axios.get<SlackUserStatusResponse>('/v1/slack/user/status');
}
